import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";

export default function ForceReloadDialog(): JSX.Element {
    const theme = useTheme();

    return (
        <Dialog open>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6" color={theme.palette.error.main}>
                        APPLICATION ERROR DETECTED
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <Grid item flex={1}>
                        <Typography textAlign={"center"} sx={{ p: 1 }}>
                            AN UNRECOVERABLE ERROR HAS OCCURRED
                        </Typography>
                        <Typography textAlign={"center"} sx={{ p: 1, pb: 1 }}>
                            CLICK THE BUTTON BELOW TO RESTART THE APP AND TRY AGAIN. IF THE ERROR RE-OCCURS, CLOSE ALL APPS, RESTART THE IPAD THEN TRY AGAIN.
                        </Typography>
                        <Typography textAlign={"center"} sx={{ p: 1, pb: 4 }}>
                            PLEASE CONTACT SUPPORT IF YOU ARE STILL UNABLE TO CREATE YOUR TICKET.
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button
                        variant="contained"
                        color={"error"}
                        sx={{ m: 1 }}
                        onClick={() => {
                            window.location.reload();
                        }}>
                        RESTART APP
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
